import { Types } from './actions';

export const INITIAL_STATE = {
  open: false,
};

export default function help(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.OPEN_HELP:
      return {
        open: true,
      };
    case Types.CLOSE_HELP:
      return {
        open: false,
      };
    default:
      return state;
  }
}
